import { usePromo } from '@/context/PromoContext';
import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getCart } from '@/queries/cart.queries';
import { CULT_SKU_ID, CULT_BENEFIT_ID } from '@/constants';
import MaintenancePage from './MaintenancePage';
// import { CouponLoaderBottomSheet } from '@/components/promos/cult-fit/CouponBottomSheets';

const BaseCult = () => {
  const {
    setEnabledQueries,
    cult: {
      selectedCity = null,
      setSelectedCity = () => {},
      showMaintenance = false,
      queries: { cultSkuDetails = null, querySkuMembership = null } = {},
    } = {},
  } = usePromo() ?? {};

  const navigate = useNavigate();
  const location = useLocation();
  const { data: cartData = { cart: { items: [] } }, isLoading: isCartLoading } =
    useQuery(getCart());

  useEffect(() => {
    setEnabledQueries?.({
      cultPromoDetails: true,
      // querySkuCount: true,
      querySkuCount: false,
      querySkuMembership: true,
    });
  }, []);

  useEffect(() => {
    if (cultSkuDetails?.data && selectedCity == null) {
      const city = cultSkuDetails?.data?.pricing?.[0];
      setSelectedCity?.(city?.id ?? null);
    }
  }, [cultSkuDetails?.data]);

  useEffect(() => {
    // Only proceed with navigation logic if both membership and cart queries have finished loading
    if (querySkuMembership?.isLoading || isCartLoading) {
      return;
    }

    // Membership check takes precedence - if user has membership, redirect to status
    if (
      querySkuMembership?.data?.isMembershipPresent &&
      location.pathname !== '/retail/cult-fit/status'
    ) {
      navigate('/retail/cult-fit/status?status=SUCCESS');
      return;
    }

    // Only check cart if no membership is present
    if (
      !querySkuMembership?.data?.isMembershipPresent &&
      cartData?.cart?.items
    ) {
      const hasCultSku = cartData.cart.items.some(
        (item) =>
          item.sku === CULT_SKU_ID || item.benefitId === CULT_BENEFIT_ID,
      );

      // Navigate to landing if no cult SKU in cart and currently on checkout
      if (!hasCultSku && location.pathname === '/retail/cult-fit/checkout') {
        navigate('/retail/cult-fit');
      }
    }
  }, [
    querySkuMembership?.data,
    querySkuMembership?.isLoading,
    cartData?.cart?.items,
    isCartLoading,
    location.pathname,
    navigate,
  ]);

  if (showMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <>
      <Outlet />
      {/* <CouponLoaderBottomSheet /> */}
    </>
  );
};

export default BaseCult;
